module.exports = __webpack_public_path__ + "json/market18-0.json?178dd2e2eddca7723889f909e13e504d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market18-0.json
// module id = 1261
// module chunks = 3